import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'wechat-artist-import',
        path: 'wechat-artist-import',
        component: () => import('../pages/wechat-artist-import/WechatArtistImportPage.vue'),
      },
      {
        name: 'certificates',
        path: 'certificates',
        component: RouteViewComponent,
        children: [
          {
            name: 'certificates-list',
            path: 'list',
            component: () => import('../pages/users/UsersPage.vue'),
          },
          {
            name: 'certificates-add',
            path: 'add',
            meta: {
              name: '新增证书会员',
              pname: 'software.menu.software',
            },
            component: () => import('@/pages/users/addUser/AddUserPage.vue'),
          },
          {
            name: 'certificates-edit',
            path: ':memberSn/edit',
            meta: {
              name: '编辑证书会员',
              pname: 'software.menu.software',
            },
            component: () => import('@/pages/users/addUser/AddUserPage.vue'),
          },
        ],
      },
      {
        name: 'website-members',
        path: 'website-members',
        component: RouteViewComponent,
        children: [
          {
            name: 'website-members-list',
            path: 'list',
            component: () => import('../pages/artists/ArtistsPage.vue'),
          },
          {
            name: 'website-members-add',
            path: 'add',
            meta: {
              name: '新增网站成员内容',
              pname: 'software.menu.software',
            },
            component: () => import('@/pages/artists/addArtist/AddArtistPage.vue'),
          },
          {
            name: 'website-members-edit',
            path: ':artistId/edit',
            meta: {
              name: '编辑网站成员内容',
              pname: 'software.menu.software',
            },
            component: () => import('@/pages/artists/addArtist/AddArtistPage.vue'),
          },
        ],
      },
      {
        name: 'artworks',
        path: 'artworks',
        component: RouteViewComponent,
        children: [
          {
            name: 'artworks-list',
            path: 'artworks-list',
            component: () => import('../pages/artworks/ArtworksPage.vue'),
          },
          {
            name: 'artwork-reservations',
            path: 'reservations',
            component: () => import('@/pages/artwork-reservations/ArtworkReservationsPage.vue'),
          },
          {
            name: 'artworks-add',
            path: 'artworks-add',
            meta: { name: '新增作品', pname: 'artworks.menu' },
            component: () => import('@/pages/artworks/AddArtworkPage.vue'),
          },
          {
            name: 'artworks-edit',
            path: ':id/edit',
            meta: { name: '编辑作品', pname: 'artworks.menu' },
            component: () => import('@/pages/artworks/AddArtworkPage.vue'),
          },
        ],
      },
      {
        name: 'cms-pages',
        path: 'cms-pages',
        component: RouteViewComponent,
        children: [
          {
            name: 'cms-pages-list',
            path: 'cms-pages-list',
            component: () => import('../pages/cms-pages/CmsPagesPage.vue'),
          },
          {
            name: 'icaa-team',
            path: 'icaa-team',
            meta: { name: '关于页核心团队', pname: 'cms-pages.menu' },
            component: () => import('@/pages/cms-pages/icaa-team/IcaaTeamPage.vue'),
          },
          {
            name: 'cms-pages-edit',
            path: ':pageKey/edit',
            meta: { name: '编辑协会页面', pname: 'cms-pages.menu' },
            component: () => import('@/pages/cms-pages/editor/EditCmsPagePage.vue'),
          },
        ],
      },
      {
        // 协会动态 (Blog): 文章 / 分类 / 标签
        name: 'blog',
        path: 'blog',
        component: RouteViewComponent,
        children: [
          // ---------------- 文章 ----------------
          {
            name: 'blog-articles-list',
            path: 'articles',
            component: () => import('../pages/blog/articles/BlogArticlesPage.vue'),
          },
          {
            name: 'blog-articles-add',
            path: 'articles/add',
            meta: { name: '新增文章', pname: 'blog.menu' },
            component: () => import('../pages/blog/articles/editor/EditBlogArticlePage.vue'),
          },
          {
            name: 'blog-articles-edit',
            path: 'articles/:id/edit',
            meta: { name: '编辑文章', pname: 'blog.menu' },
            component: () => import('../pages/blog/articles/editor/EditBlogArticlePage.vue'),
          },
          // ---------------- 分类 ----------------
          {
            name: 'blog-categories-list',
            path: 'categories',
            component: () => import('../pages/blog/categories/BlogCategoriesPage.vue'),
          },
          {
            name: 'blog-categories-add',
            path: 'categories/add',
            meta: { name: '新增分类', pname: 'blog.menu' },
            component: () => import('../pages/blog/categories/addCategory/AddBlogCategoryPage.vue'),
          },
          {
            name: 'blog-categories-edit',
            path: 'categories/:key/edit',
            meta: { name: '编辑分类', pname: 'blog.menu' },
            component: () => import('../pages/blog/categories/addCategory/AddBlogCategoryPage.vue'),
          },
          // ---------------- 标签 ----------------
          {
            name: 'blog-tags-list',
            path: 'tags',
            component: () => import('../pages/blog/tags/BlogTagsPage.vue'),
          },
          {
            name: 'blog-tags-add',
            path: 'tags/add',
            meta: { name: '新增标签', pname: 'blog.menu' },
            component: () => import('../pages/blog/tags/addTag/AddBlogTagPage.vue'),
          },
          {
            name: 'blog-tags-edit',
            path: 'tags/:key/edit',
            meta: { name: '编辑标签', pname: 'blog.menu' },
            component: () => import('../pages/blog/tags/addTag/AddBlogTagPage.vue'),
          },
        ],
      },
      {
        name: 'projects',
        path: 'projects',
        component: () => import('../pages/projects/ProjectsPage.vue'),
      },
      {
        name: 'payments',
        path: '/payments',
        component: RouteViewComponent,
        children: [
          {
            name: 'payment-methods',
            path: 'payment-methods',
            component: () => import('../pages/payments/PaymentsPage.vue'),
          },
          {
            name: 'billing',
            path: 'billing',
            component: () => import('../pages/billing/BillingPage.vue'),
          },
          {
            name: 'pricing-plans',
            path: 'pricing-plans',
            component: () => import('../pages/pricing-plans/PricingPlans.vue'),
          },
        ],
      },
      {
        name: 'faq',
        path: '/faq',
        component: () => import('../pages/faq/FaqPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

// 路由白名单 - 使用路由名称
const whiteList = ['login']

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('access_token')
  const isPublicRoute = whiteList.includes(to.name as string)

  const isInvalidToken = !token || token === 'null' || token === 'undefined'

  console.log('token:', token)

  // 未登录
  if (isInvalidToken) {
    if (isPublicRoute) {
      return next()
    } else {
      console.log('未登录，跳转 login')
      return next({ name: 'login', replace: true })
    }
  }

  // 已登录
  if (to.name === 'login') {
    console.log('已登录访问 login，跳转 dashboard')
    return next({ name: 'dashboard', replace: true })
  }

  // 正常放行
  next()
})

export default router
